const XLM = ({ ...props }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="10" fill="white" />
    <path
      d="M5.01101 10.6795C4.98241 10.4539 4.96802 10.2267 4.96793 9.9992C4.96909 9.09148 5.19953 8.19982 5.63645 7.41255C6.07336 6.62528 6.70157 5.96971 7.45887 5.51077C8.21616 5.05184 9.07625 4.80546 9.95395 4.79606C10.8316 4.78665 11.6965 5.01454 12.4628 5.45714L13.6148 4.85001C12.6965 4.16071 11.6118 3.7474 10.4805 3.65578C9.34923 3.56416 8.21549 3.79779 7.20459 4.33084C6.19369 4.86389 5.34498 5.67561 4.75228 6.67628C4.15957 7.67696 3.84595 8.82763 3.84607 10.0011C3.84607 10.1632 3.85201 10.3246 3.86391 10.4854C3.88058 10.7131 3.83174 10.9408 3.72355 11.1399C3.61537 11.339 3.45266 11.5005 3.2559 11.6042L2.72728 11.883V13.1832L17.2727 5.51824V4.21869L5.01101 10.6795Z"
      fill="black"
    />
    <path
      d="M17.2727 6.81955L5.79071 12.8654L2.72728 14.4806V15.7796L14.9921 9.31682C15.0207 9.54388 15.0351 9.77261 15.0352 10.0016C15.0346 10.9104 14.8042 11.8032 14.3669 12.5914C13.9296 13.3796 13.3005 14.0359 12.5421 14.4949C11.7837 14.954 10.9224 15.2 10.0437 15.2084C9.16496 15.2169 8.29938 14.9875 7.53289 14.543L7.47135 14.5767L6.38457 15.1495C7.30269 15.8388 8.38721 16.2523 9.5183 16.3441C10.6494 16.4359 11.783 16.2026 12.7939 15.6699C13.8048 15.1372 14.6536 14.3259 15.2466 13.3256C15.8396 12.3253 16.1536 11.1749 16.1539 10.0016C16.1539 9.83804 16.1478 9.67448 16.1361 9.51283C16.1195 9.2852 16.1682 9.05756 16.2763 8.85851C16.3844 8.65945 16.5469 8.49786 16.7435 8.39403L17.2727 8.11528V6.81955Z"
      fill="black"
    />
  </svg>
);
export default XLM;
